import React, { useEffect } from "react";
import '../Styles/GroupReservationReview.scss';
import FastTrackDisplayWidget from "./FastTrackDisplayWidget.js";
import DateHelpers from "../Helper/DateHelpers.js";
import { GroupPageOptions } from "../Constants/RegistrationPageOptions.js";
import GenerateRandomCode from "../Helper/GenerateRandomCode.js";
import { useNavigate } from "react-router-dom";


const ReservationReview = ({ isFastTrack, fastTrack, numberOfSpots, amountDue, paymentAmount, week, selectedPage, setSelectedPage, ProcessReservation}) => {
   console.log(fastTrack)
   var navigate = useNavigate();
   var IsFastTrack = (fastTrack.slotsReserved != '') ? true : false
   const HandleSubmit = async (event) => {
      ProcessReservation()
   }
   const NavigateBack = (event) => {
      event.preventDefault()
      fastTrack.slotsReserved == '' ? setSelectedPage(GroupPageOptions.WeekSelection) : setSelectedPage(GroupPageOptions.ReservationSpotSelection)
   }
   return (
         <div className="GroupRegistrationReviewContainer">
            <div className="GroupRegistrationReviewContent">
               <div className="GroupRegistrationReviewHeading">
                  Review Reservation Details
               </div>
               <div className="GroupRegistrationReviewDetails">
                  <div className="GroupRegistrationReviewWeekSelected">
                     <h3>Week Selected: </h3>
                     <p>{week.camp_name}</p>
                  </div>
                  <div className="GroupRegistrationReviewDates">
                     <h3>Dates: </h3>
                     <p>{DateHelpers.getEventDateRange(week.begin_date, week.end_date)}</p>
                  </div>
                  <div className="GroupRegistrationReviewSpeaker">
                     <h3>Speaker: </h3>
                     <p>{week.guest_speaker_name}</p>
                  </div>
               </div>
               {isFastTrack ? (
                  <div>
                     <FastTrackDisplayWidget
                        fastTrack={fastTrack}
                        numberOfSpots={numberOfSpots}
                        paymentAmount={paymentAmount} />
                  </div>) : (
                     <div className="GroupRegistrationReviewDates">
                     <h3>Slots Reserved:</h3>
                     <p>
                        {numberOfSpots}
                     </p>
                  </div>
                  )
               }
               <div className="GroupRegistrationReviewButtons">
                  <div className="GroupRegistrationReviewBackButton">
                     <button onClick={NavigateBack} >Previous</button>
                  </div>
                  <div className="GroupRegistrationReviewSubmitButton">
                     {isFastTrack ? (<button onClick={() => setSelectedPage(GroupPageOptions.ReservationPayment)}>Payment</button>) :(<button onClick={HandleSubmit}>Confirm</button>)}
                  </div>
               </div>
            </div>
         </div>
   )
}

export default ReservationReview;